import { Stack, styled, Typography, type CSSObject } from '@mui/material';

export const StyledTitle = styled(Typography)(({ theme }) => ({
  ...(theme.mixins.neutralGradient as CSSObject),
  backgroundClip: 'text',
  WebkitBackgroundClip: 'text',
  WebkitTextFillColor: 'transparent',
  paddingBottom: theme.spacing(0.5),
}));

export const StyledCaseStudySection = styled(Stack)<{ noGap?: boolean }>(
  ({ noGap = false, theme }) => ({
    maxWidth: '660px',
    width: '100%',
    display: 'flex',
    alignSelf: 'center',
    gap: noGap ? 0 : theme.spacing(2),
    padding: theme.spacing(2, 0),
    [theme.breakpoints.down('md')]: {
      gap: noGap ? 0 : theme.spacing(1),
      padding: theme.spacing(1, 0),
    },
  })
);
